
import formInputsTypes from '../simulatorConstant';
import infoMesure from './infoMesure';
import { lamesRM } from './data';
import CoulissesRideau from 'assets/img/coulisse-rideau.png';
import SansCoulissesRideau from 'assets/img/sans-coulisse-rideau.png';

const coulisseRM = {
	id: 'coulisseRM',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Coulisses',
	name: 'coulisseRM',
	className: 'col-6',
	nextStepData: infoMesure,
	nextStep: false,
	options: [
	{
		id: 'sansCOULL',
		label: 'Sans coulisses',
		value: 'Sans coulisses',
		imageUrl: SansCoulissesRideau,
		nextStep: false,
		description:
			'- Configuration sans coulisses.',
	},
	{
		id: 'avecCOULL',
		label: 'Avec coulisses',
		value: 'Avec coulisses',
		imageUrl: CoulissesRideau,
		nextStep: false,
		description:
			'- Configuration avec coulisses.',
	},
],

};
const tablierRideauMetalliqueData = {
	id: 'TABLIERRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Type de lames',
	name: 'TABLIERRMData',
	className: 'col-6',
	classGroup: 'SCategory',
	nextStepData: coulisseRM,
	nextStep: false,
	options: lamesRM
};


export default tablierRideauMetalliqueData;
